import BootstrapInput from "@/components/BootstrapInput";
import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useGeneralApiCall } from "@/services/useGeneralApiCall";
import { showToast } from "@/api/notification";
import { fetchStylesGlobal } from "../features/styleSlice";
import { useAppDispatch } from "../hooks/hooks";
import LoadingComponent from "@/components/Loading";
// import SelectCategory from "@/components/SelectCategory";
import ImageDrop from "@/components/Imagedrop";
import { Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SelectApparelCategory from "@/components/SelectApparelCategory";
import { ImageObj } from "@/types";
import TagSelector from "../components/TagsInputs";

function AddNewStyle() {
  const dispatch = useAppDispatch();
  const [tags, setTags] = useState<string[]>([]);
  const [styleName, setStyleName] = useState<string>("");
  const [styleNumber, setStyleNumber] = useState<string>("");
  const [location, setLocation] = useState<string>("");
  const [extraImage, setExtraImage] = useState<ImageObj[]>([]);
  const [msrCategoryId] = useState<string>("");
  const [categoryId, setCategoryId] = useState<string | null>("");
  const { postApi, loading } = useGeneralApiCall();
  const [isValid, setIsValid] = useState(false);
  const [isInvalid, setIsInvalid] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [isValid1, setIsValid1] = useState(false);
  const [isInvalid1, setIsInvalid1] = useState(false);
  const [feedback1, setFeedback1] = useState("");
  const [suggestions, setSuggestions] = useState<string[]>([]);

  const navigate = useNavigate();

  const { getApi } = useGeneralApiCall();
  useEffect(() => {
    if (!styleName.trim()) {
      setIsValid(false);
      setIsInvalid(false);
      setFeedback("");
      setSuggestions([]);
      return;
    }

    const timer = setTimeout(() => {
      checkStyleName(styleName);
    }, 500); // debounce

    return () => clearTimeout(timer);
  }, [styleName]);

  useEffect(() => {
    if (!styleNumber.trim()) {
      setIsValid1(false);
      setIsInvalid1(false);
      setFeedback1("");
      return;
    }

    const timer = setTimeout(() => {
      checkStyleNumber(styleNumber);
    }, 500); // debounce

    return () => clearTimeout(timer);
  }, [styleNumber]);
  // ✅ Real-time style number validation

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", styleName);
    formData.append("locations", location);
    if (categoryId === "" && msrCategoryId === "") {
      showToast({ message: "Please select a category.", type: "error" });
      return;
    }
    formData.append("category_id", categoryId!);
    formData.append("msr_category", msrCategoryId);
    formData.append("style_number", styleNumber);

    formData.append("tags", JSON.stringify(tags));

    extraImage.forEach((imageObj) => {
      formData.append("images", imageObj.file);
    });
    try {
      const res = await postApi("api/style/v1/style/", formData);
      if (res.status === 201) {
        showToast({ message: res.message, type: "success" });
        dispatch(fetchStylesGlobal());
      }
    } catch (error: unknown) {
      let errorMessage = "Something went wrong";
      if (error instanceof Error) {
        errorMessage = error.message;
      }
      showToast({
        message: errorMessage,
        type: "error",
      });
    }

    // setStyleName("");
    // setStyleNumber("");
    // setLocation("");
    // setCategoryId("");
    // setMsrCategoryId("");
    // setExtraImage([]);
  };

  console.log("Extra image:", extraImage);

  const checkStyleName = async (name: string) => {
    try {
      const res = await getApi(
        `/api/style/v1/verify-style-name/${encodeURIComponent(name)}/`
      );
      if (res.message === "No Style Name exists.") {
        setIsValid(true);
        setIsInvalid(false);
        setFeedback("✔ style name is available");
      } else {
        setIsValid(false);
        setIsInvalid(true);
        setFeedback("✘ style name already exists");
      }
    } catch (error) {
      console.error(error);
      setIsValid(false);
      setIsInvalid(true);
      setFeedback("Error checking style name");
    }
  };

  const checkStyleNumber = async (number: string) => {
    try {
      const res = await getApi(
        `/api/style/v1/verify-style-number/${encodeURIComponent(number)}/`
      );
      if (res.message === "No Style Number exists.") {
        setIsValid1(true);
        setIsInvalid1(false);
        setFeedback1("✔ style number is available");
      } else {
        setIsValid1(false);
        setIsInvalid1(true);
        setFeedback1("✘ style number already exists");
      }
    } catch (error) {
      console.error(error);
      setIsValid1(false);
      setIsInvalid1(true);
      setFeedback1("Error checking style number");
    }
  };

  const fetchSuggestions = async (name: string) => {
    try {
      const res = await getApi(
        `api/style/v1/get-similar-style-names/${encodeURIComponent(name)}/`
      );
      console.log(res);
      setSuggestions(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (styleName) {
      fetchSuggestions(styleName);
    }
  }, [styleName]);

  return (
    <>
      {loading ? (
        <LoadingComponent />
      ) : (
        <div className="mt-4 flex flex-col">
          {/* Sticky Submit Button */}
          <div className="fixed top-4 right-4 z-50">
            <button
              className="bg-green-500  text-white px-6 py-3 rounded-lg shadow-lg !text-[18px] font-semibold disabled:bg-gray-400 disabled:cursor-not-allowed transition-all duration-200 hover:shadow-xl"
              onClick={(e) => {
                e.preventDefault();
                const form = document.querySelector('form');
                if (form) {
                  form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
                }
              }}
              disabled={!isValid || loading}
            >
              {loading ? "Submitting..." : "Submit Style"}
            </button>
          </div>

          <div className="flex w-full justify-between items-center mb-4">
            <div className="text-center text-[50px] border-b mb-4 w-full">
              ADD NEW STYLE
            </div>
            <button
              className="flex justify-start bg-gray-100 px-4 py-2 border !text-[20px]"
              onClick={() => navigate("/bulk-create")}
            >
              Bulk Create
            </button>
          </div>

          {/* <DummyContent /> */}

          <Form onSubmit={handleSubmit} className="flex flex-col gap-2">
            <BootstrapInput
              value={styleName}
              setValue={setStyleName}
              placeholder="Enter Style Name"
              label="Style Name"
              isValid={isValid}
              isInvalid={isInvalid}
              feedback={feedback}
              required
            />

            {suggestions.length > 0 && (
              <div style={{ marginTop: "8px" }}>
                <small>Similar names ({suggestions.length}):</small>
                <div style={{ marginTop: "4px", display: "flex", gap: "8px" }}>
                  {suggestions.map((s, i) => (
                    <Chip
                      key={i}
                      label={s}
                      variant="outlined"
                      sx={{ fontFamily: "'Shadows Into Light', cursive" }}
                    />
                  ))}
                </div>
              </div>
            )}
            <BootstrapInput
              value={styleNumber}
              setValue={setStyleNumber}
              placeholder="Enter Style Number"
              label="Style Number"
              isValid={isValid1}
              isInvalid={isInvalid1}
              feedback={feedback1}
            />

            {/* <SelectCategory
              msrCategoryId={msrCategoryId}
              categoryId={categoryId}
              setMsrCategoryId={setMsrCategoryId}
              setCategoryId={setCategoryId}
            /> */}

            <SelectApparelCategory
              categoryId={categoryId}
              setCategoryId={setCategoryId}
              addCategory={true}
            />

            <ImageDrop
              label="Images"
              images={extraImage}
              setImages={setExtraImage}
            />

            <TagSelector selectedTags={tags} setSelectedTags={setTags} />

            <BootstrapInput
              value={location}
              setValue={setLocation}
              placeholder="Enter Location"
              label="Location"
            />
            <Button type="submit" className="mt-4" disabled={!isValid}>
              {loading ? "Submitting..." : "Submit"}
            </Button>
          </Form>
        </div>
      )}
    </>
  );
}

export default AddNewStyle;
